var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "workflow-permission" } }, [
    _c(
      "div",
      { staticClass: "table-header" },
      [
        _c("a-input-search", {
          staticClass: "search-input",
          attrs: {
            value: _vm.searchText,
            placeholder: _vm.$t("message.search"),
          },
          on: {
            input: function ($event) {
              return _vm.searchTextHandle($event)
            },
            search: _vm.onSearch,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "scrollContainer",
        staticClass: "table-scroll-container",
        on: { scroll: _vm.onScroll },
      },
      [
        _c("table", { staticClass: "users-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "col-avatar" }),
              _vm._v(" "),
              _c("th", { staticClass: "col-name" }, [
                _vm._v(_vm._s(_vm.$t("message.username"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "col-permission" }, [
                _vm._v(_vm._s(_vm.$t("task.deleteCard"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "col-permission" }, [
                _vm._v(_vm._s(_vm.$t("task.createCard"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "col-permission" }, [
                _vm._v(_vm._s(_vm.$t("task.editCard"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "col-permission" }, [
                _vm._v(_vm._s(_vm.$t("task.dragCard"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "col-permission" }, [
                _vm._v("Kart Arşivleme"),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "col-permission" }, [
                _vm._v("Kart Tamamlama"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.getFilteredRows(), function (row, rowIndex) {
              return _c(
                "tr",
                { key: row._id, class: { "stripe-row": rowIndex % 2 === 1 } },
                [
                  _c(
                    "td",
                    { staticClass: "col-avatar" },
                    [
                      _c("agent-avatar", {
                        attrs: {
                          "user-i-d": row._id,
                          size: 30,
                          "is-named": false,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-name" }, [
                    _vm._v(
                      _vm._s(
                        (row.name || "").length > 15
                          ? (row.name || "").slice(0, 11) + "..."
                          : row.name || ""
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-permission" }, [
                    _c("div", { staticClass: "checkbox-wrapper" }, [
                      _vm.loadingStates["deleteTask_" + row._id]
                        ? _c("div", { staticClass: "spinner" })
                        : _c("div", {
                            class: [
                              "custom-checkbox",
                              _vm.isHavePermission("deleteTask", row._id)
                                ? "checked"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                _vm.toggleDeleteTaskPermission(
                                  "deleteTask",
                                  row._id,
                                  !_vm.isHavePermission("deleteTask", row._id)
                                )
                              },
                            },
                          }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-permission" }, [
                    _c("div", { staticClass: "checkbox-wrapper" }, [
                      _vm.loadingStates["createTask_" + row._id]
                        ? _c("div", { staticClass: "spinner" })
                        : _c("div", {
                            class: [
                              "custom-checkbox",
                              _vm.isHavePermission("createTask", row._id)
                                ? "checked"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                _vm.toggleDeleteTaskPermission(
                                  "createTask",
                                  row._id,
                                  !_vm.isHavePermission("createTask", row._id)
                                )
                              },
                            },
                          }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-permission" }, [
                    _c("div", { staticClass: "checkbox-wrapper" }, [
                      _vm.loadingStates["editTask_" + row._id]
                        ? _c("div", { staticClass: "spinner" })
                        : _c("div", {
                            class: [
                              "custom-checkbox",
                              _vm.isHavePermission("editTask", row._id)
                                ? "checked"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                _vm.toggleDeleteTaskPermission(
                                  "editTask",
                                  row._id,
                                  !_vm.isHavePermission("editTask", row._id)
                                )
                              },
                            },
                          }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-permission" }, [
                    _c("div", { staticClass: "checkbox-wrapper" }, [
                      _vm.loadingStates["draggingTask_" + row._id]
                        ? _c("div", { staticClass: "spinner" })
                        : _c("div", {
                            class: [
                              "custom-checkbox",
                              _vm.isHavePermission("draggingTask", row._id)
                                ? "checked"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                _vm.toggleDeleteTaskPermission(
                                  "draggingTask",
                                  row._id,
                                  !_vm.isHavePermission("draggingTask", row._id)
                                )
                              },
                            },
                          }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-permission" }, [
                    _c("div", { staticClass: "checkbox-wrapper" }, [
                      _vm.loadingStates["archiveTask_" + row._id]
                        ? _c("div", { staticClass: "spinner" })
                        : _c("div", {
                            class: [
                              "custom-checkbox",
                              _vm.isHavePermission("archiveTask", row._id)
                                ? "checked"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                _vm.toggleDeleteTaskPermission(
                                  "archiveTask",
                                  row._id,
                                  !_vm.isHavePermission("archiveTask", row._id)
                                )
                              },
                            },
                          }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-permission" }, [
                    _c("div", { staticClass: "checkbox-wrapper" }, [
                      _vm.loadingStates["doneTask_" + row._id]
                        ? _c("div", { staticClass: "spinner" })
                        : _c("div", {
                            class: [
                              "custom-checkbox",
                              _vm.isHavePermission("doneTask", row._id)
                                ? "checked"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                _vm.toggleDeleteTaskPermission(
                                  "doneTask",
                                  row._id,
                                  !_vm.isHavePermission("doneTask", row._id)
                                )
                              },
                            },
                          }),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.loadingMore
          ? _c("div", { staticClass: "load-more-indicator" }, [
              _c("div", { staticClass: "spinner" }),
              _vm._v(" "),
              _c("span", [_vm._v("Yükleniyor...")]),
            ])
          : _vm.hasMore
          ? _c("div", {
              ref: "loadMoreTrigger",
              staticClass: "load-more-trigger",
            })
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }